// client/src/components/agent/AgentView.jsx
import { useState, useEffect } from 'react';
import { theme } from '../../theme';
import { useAgentSocket } from '../../hooks/useAgentSocket';
import AgentTopBar from './AgentTopBar';
import AgentSidebar from './AgentSidebar';
import ConversationsView from './ConversationsView';
import ListContactsView from './ListContactsView';
import ContactsView from './ContactsView';

export default function AgentView({ token, onLogout }) {
  const [section, setSection] = useState('conversations');
  const [status, setStatus] = useState('online');
  const [customFields, setCustomFields] = useState([]);

  const username = localStorage.getItem('username') || 'Agente';

  useEffect(() => {
    fetch('/api/agent/custom-fields', { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then(setCustomFields)
      .catch(() => {});
  }, [token]);

  const socketActions = useAgentSocket(token, {
    onAgentStatusChanged: () => {},
  });

  const handleStatusChange = (newStatus) => {
    setStatus(newStatus);
    socketActions.changeStatus(newStatus);
  };

  const handleLogout = () => {
    socketActions.changeStatus('offline');
    onLogout();
  };

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', height: '100vh',
      backgroundColor: theme.colors.background, overflow: 'hidden',
    }}>
      <AgentTopBar username={username} status={status} onStatusChange={handleStatusChange} onLogout={handleLogout} />
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <AgentSidebar active={section} onSelect={setSection} />
        {section === 'conversations' && (
          <ConversationsView token={token} socket={socketActions} />
        )}
        {section === 'lists' && (
          <ListContactsView token={token} customFields={customFields} />
        )}
        {section === 'contacts' && (
          <ContactsView token={token} customFields={customFields} />
        )}
      </div>
    </div>
  );
}
